import { apiFetch } from "./utils";
import { API_ENDPOINTS, LS_CURRENT_SEASON} from "../config/api";
import { Season, SeasonEnrollment } from "../types";

export const getListSeasons = async (): Promise<Season[]> => {
  return apiFetch(API_ENDPOINTS.SEASONS);
};

export const getSeason = async (id: number): Promise<Season> => {
  return apiFetch(API_ENDPOINTS.SEASON(id));
};

export const getDefaultSeason = async (): Promise<Season> => {
  return apiFetch(API_ENDPOINTS.DEFAULT_SEASON);
};

export const createSeason = async (data: Partial<Season>): Promise<Season> => {
  return apiFetch(API_ENDPOINTS.SEASONS, {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateSeason = async (id: number, data: Partial<Season>): Promise<Season> => {
  return apiFetch(API_ENDPOINTS.SEASON(id), {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteSeason = async (id: number): Promise<void> => {
  return apiFetch(API_ENDPOINTS.SEASON(id), {
    method: "DELETE",
  });
};

export const getCurrentSeason = async (): Promise<Season> => {
  // Stagione attiva
  const json_current_season = localStorage.getItem(LS_CURRENT_SEASON);
  if (json_current_season) {
    try {
      return JSON.parse(json_current_season);
    } catch {
      localStorage.removeItem(LS_CURRENT_SEASON);
    }
  }
  return getDefaultSeason();
};

export const getListSeasonEnrollments = async (seasonId: number): Promise<SeasonEnrollment[]> => {
  return apiFetch(API_ENDPOINTS.SEASON_ENROLLMENTS(seasonId));
};

export const createSeasonEnrollments = async (seasonId: number, data: { user_ids: number[] }): Promise<SeasonEnrollment[]> => {
  return apiFetch(API_ENDPOINTS.SEASON_ENROLLMENTS(seasonId), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
};
